import { render, staticRenderFns } from "./Statutes.vue?vue&type=template&id=5ae09c4b&scoped=true&"
import script from "./Statutes.vue?vue&type=script&lang=js&"
export * from "./Statutes.vue?vue&type=script&lang=js&"
import style0 from "./Statutes.vue?vue&type=style&index=0&id=5ae09c4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae09c4b",
  null
  
)

export default component.exports